var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_menu_24px","d":"M3,28.38H36.57V24.65H3Zm0-9.325H36.57v-3.73H3ZM3,6V9.73H36.57V6Z","transform":"translate(-3 -6)","fill":"#efefef"}));
}

Hamburger.defaultProps = {"width":"33.57","height":"22.38","viewBox":"0 0 33.57 22.38"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
